import { Injectable } from '@angular/core';
import { GridSettings } from '@shared/components/customized-grid/grid-settings/gird-settings.interface';

const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};

@Injectable()
export class GridStatePersistingService {
  constructor() { }

  public get<T>(token: string): T {
    const settings = localStorage.getItem(token);
    return settings ? JSON.parse(settings) : settings;
  }

  public remove<T>(token: string): void {
    localStorage.removeItem(token);
  }

  public set<T>(token: string, gridConfig: GridSettings): void {
    localStorage.setItem(token, JSON.stringify(gridConfig, getCircularReplacer()));
  }
}
